import { GetterTree } from 'vuex';
import { Retailer, IRetailer } from '@/interfaces/Retailer';
import { IShoppingListCategory, IShoppingListItem } from '@/interfaces/ShoppingList';
import { IPromotion } from '@/interfaces/Promotion';
import { Tab } from '@/interfaces/Tab';
import { ICard, DefaultCard, CardSize } from '@/interfaces/Card';
import { Partner } from '@/interfaces/Partner';
import { ICallToAction } from '@/interfaces/CallToActionTypes';
import { IMxrConfig, MxrType } from '@/interfaces/MxrConfig';
import { ILocation } from '@/interfaces/Location';
import { ProductShoppingListSection } from '@/components/tabs/components/product-shopping-list/ProductShoppingList';
import MxrRetailer from '@/interfaces/MxrRetailer';
import RetailerOffer from '@/interfaces/RetailerOffer';
import { PromotionCarouselItem } from '@/interfaces/PromotionCarouselItem';
import { ProductShoppingListItem } from '@/interfaces/ProductShoppingListItem';
import { Dictionary } from  '@/@types/index.d';
import {
    GET_ACTIVE_CARD_INDEX,
    GET_ACTIVE_CARD_POSITION,
    GET_ALL_BASE_INGREDIENTS,
    GET_BASE_INGREDIENTS_BY_SHOPPING_LIST_ID,
    GET_BASE_INGREDIENTS_PROMOTIONS,
    GET_BASE_INGREDIENTS_PROMOTIONS_AND_MAX_OFFERS,
    GET_BUMP_ANIMATION,
    GET_CARDS,
    GET_CAROUSEL_BASE_INGREDIENTS,
    GET_CURRENT_CARD,
    GET_CURRENT_MXR_RETAILER,
    GET_CUSTOM_FOOTER_ENABLED,
    GET_CUSTOM_FOOTER_TEXT,
    GET_FOOTER_CTA,
    GET_FULFILLMENT_STORE,
    GET_GO_TO_CART_OPEN,
    GET_INTEGRATED_RETAILER,
    GET_IS_BETA,
    GET_IS_DEFAULT,
    GET_IS_TAKEOVER,
    GET_ITEM_ID_BASE_INGREDIENT_MAP,
    GET_ITEM_ID_OFFERS_COUNT,
    GET_KROGER_AUTH_CONFIG,
    GET_LOADING_PROMOTIONS,
    GET_MAX_OFFERS,
    GET_MERCURY_LOCATION_RESULT,
    GET_MXR_CONFIG,
    GET_MXR_CONFIG_URL,
    GET_MXR_ID,
    GET_MXR_JSON_DATA,
    GET_MXR_RETAILER_LOCATIONS,
    GET_MXR_TYPE,
    GET_PARTNER,
    GET_PRODUCT_SHOPPING_LIST_SECTIONS,
    GET_PROMOTIONS,
    GET_RANDOMIZE_CARDS_DISPLAYED,
    GET_RANDOMIZE_OFFERS_DISPLAYED,
    GET_RETAILER,
    GET_RETAILER_LOCATIONS_MODAL_OPEN,
    GET_RETAILER_OFFERS,
    GET_SELECTED_OFFER_IDS,
    GET_SELECTED_PRODUCT_SHOPPING_LIST_ITEMS,
    GET_SELECTED_RECIPE_ID,
    GET_SELECTED_SWAP,
    GET_SELECTED_TAB,
    GET_SESSION_ID,
    GET_SHOPPING_LIST,
    GET_SHOW_CHECKOUT_TOTAL,
    GET_SHOW_SHOPPING_LIST_CHECKBOXES,
    GET_SIZE,
    GET_STORE_PICKER_ENABLED,
    GET_SWAP_ENABLED,
    GET_SWAP_OPEN,
    GET_SWAP_OPTIONS,
    GET_TABS,
    GET_TAB_CTA,
    GET_TAKEOVER,
    GET_THEME,
    GET_VISIBLE_PROMOTIONS,
    GET_VISIBLE_PROMOTION_STRING,
    GET_VISIBLE_PROMOTION_UNIQUE_IDS,
    GET_ALL_BASE_INGREDIENTS_AND_MAX_OFFERS,
    GET_CHECKOUT_TOTAL,
    GET_PREVIOUS_CARD_INDEX,
    GET_SELECTED_TAB_INDEX,
    GET_PREVIOUS_PROMOTION,
    GET_OFFERS_COUNT_IN_CART,
	GET_CARTING_URL,
} from '../types';
import { IRootState } from './state';
import { getChainKeyByName } from '@andromeda/polaris-data-access-products';


export const getters: GetterTree<IRootState, IRootState> = {
    [GET_CURRENT_CARD]: (state): ICard => {
        if (state.config.cards && state.config.cards.length) {
            if (state.activeCardIndex === -1) {
                return DefaultCard;
            }

            if (state.activeCardIndex > state.config.cards.length) {
                return DefaultCard;
            }

            return state.config.cards[state.activeCardIndex];
        }
        return DefaultCard;
    },
    [GET_MXR_TYPE]: (state: IRootState): MxrType => state.config.mxrType,
    [GET_SIZE]: (state: IRootState): CardSize => (state.config.size === '300x435' ? CardSize.SMALL : CardSize.LARGE),
    [GET_THEME]: (state): string => state.config.theme,
    [GET_CARDS]: (state): ICard[] => state.config.cards,
    [GET_ACTIVE_CARD_INDEX]: (state): number => state.activeCardIndex,
    [GET_ACTIVE_CARD_POSITION]: (state): number => state.activeCardIndex + 1,
    [GET_PREVIOUS_CARD_INDEX]: (state): number => state.previousCardIndex,
    [GET_SELECTED_TAB]: (state): Tab => state.selectedTab,
    [GET_SELECTED_TAB_INDEX]: (state): Tab => state.selectedTabIndex,
    [GET_TABS]: (state): string[] => [
        state.config.tab1Label,
        state.config.tab2Label,
        state.config.tab3Label,
    ],
    [GET_RETAILER]: (state: IRootState): IRetailer => {
        if (state.takeover && state.mxrRetailerLocations.length && state.mxrRetailerLocations[0].FulfillmentStoreId.length) {
            const mxrRetailer = state.mxrRetailerLocations[state.currentMxrRetailerIndex];
            return new Retailer(
                0,
                state.takeover.Name,
                state.takeover.Image.url,
                {
                    address: mxrRetailer.Street,
                    state: mxrRetailer.State,
                    city: mxrRetailer.City,
                    zip: mxrRetailer.ZipCode,
                    chain: mxrRetailer.Chain,
                } as ILocation,
            );
        }
        return (state.config && state.config.retailer) ? state.config.retailer : Retailer.Default();
    },
    [GET_PARTNER]: (state: IRootState, getter): Partner => getter[GET_CURRENT_CARD].partner,
    [GET_SHOPPING_LIST]: (state, getter): IShoppingListCategory[] => {
        if (getter[GET_CURRENT_CARD]) {
            return getter[GET_CURRENT_CARD].shoppingList;
        }
        return [] as IShoppingListCategory[];
    },
    [GET_SHOW_SHOPPING_LIST_CHECKBOXES]: (state: IRootState): boolean => state.config.showShoppingList,
    [GET_SWAP_ENABLED]: (state: IRootState): boolean => state.config.swapEnabled,
    [GET_STORE_PICKER_ENABLED]: (state: IRootState): boolean => state.config.storePickerEnabled,
    [GET_SHOW_CHECKOUT_TOTAL]: (state: IRootState): boolean => state.config.showCheckoutTotal,
    [GET_PROMOTIONS]: (state: IRootState): PromotionCarouselItem[] => state.config.promotions,
    [GET_BUMP_ANIMATION]: (state: IRootState): boolean => state.config.bumpAnimation,
    [GET_RANDOMIZE_CARDS_DISPLAYED]: (state: IRootState): boolean => state.config.randomizeCardsDisplayed,
    [GET_RANDOMIZE_OFFERS_DISPLAYED]: (state: IRootState): boolean => state.config.randomizeOffersDisplayed,
    [GET_MXR_ID]: (state: IRootState): string => state.config.id,
    [GET_SESSION_ID]: (state: IRootState): string => state.sessionId,
    [GET_VISIBLE_PROMOTIONS]: (state: IRootState): IPromotion[] => state.config
        .promotions.reduce((pv: IPromotion[], cv: any) => pv.concat(cv.promotions.length ? cv.promotions : cv.defaultPromotions ), [])
        .filter((p: IPromotion) => state.visiblePromotionUniqueIds.indexOf(p.uniqueId.toString()) >= 0),
    [GET_FOOTER_CTA]: (state: IRootState): ICallToAction => state.config.footerCallToAction,
    [GET_TAB_CTA]: (state: IRootState): ICallToAction => state.config.tab3CallToAction,
    [GET_SELECTED_RECIPE_ID]: (state: IRootState): string => state.config.cards[state.activeCardIndex].recipeId,
    [GET_SELECTED_OFFER_IDS]: (state: IRootState): string[] => state.selectedOfferIds,
    [GET_CUSTOM_FOOTER_ENABLED]: (state: IRootState): boolean => state.config.customFooterEnabled,
    [GET_CUSTOM_FOOTER_TEXT]: (state: IRootState): string => state.config.customFooterText,
    [GET_RETAILER_OFFERS]: (state: IRootState): RetailerOffer[] => {
        if (state.mxrRetailerLocations.length) {
            return state.mxrRetailerLocations[state.currentMxrRetailerIndex].Offers;
        }
        return [];
    },
    [GET_MXR_RETAILER_LOCATIONS](state: IRootState): MxrRetailer[] {
        return state.mxrRetailerLocations;
    },
    [GET_CURRENT_MXR_RETAILER](state: IRootState): MxrRetailer {
        if (state.mxrRetailerLocations.length) {
            return state.mxrRetailerLocations[state.currentMxrRetailerIndex];
        }
        return MxrRetailer.CreateDefault();
    },
    [GET_PRODUCT_SHOPPING_LIST_SECTIONS]: (state: IRootState): ProductShoppingListSection[] => state.productShoppingListSections,
    [GET_SELECTED_PRODUCT_SHOPPING_LIST_ITEMS]: (state: IRootState): ProductShoppingListItem[] => {
        const items: ProductShoppingListItem[] = [];
        state.productShoppingListSections.forEach((sec) => {
            sec.Items.forEach((i) => {
                if (i.Selected) {
                    items.push(i);
                }
            });
        });
        return items;
    },
    [GET_SWAP_OPEN]: (state): boolean => state.swapSlot,
    [GET_RETAILER_LOCATIONS_MODAL_OPEN]: (state: IRootState): boolean => state.retailerLocationsModalOpen,
    [GET_IS_BETA]: (state: IRootState): boolean => state.isBeta,
    [GET_MXR_JSON_DATA]: (state: IRootState): string => state.mxrJSONData,
    [GET_TAKEOVER](state: IRootState) {
        return state.takeover;
    },
    [GET_IS_TAKEOVER](state: IRootState) {
        return state.takeover !== null;
    },
    [GET_IS_DEFAULT]: (state: IRootState): boolean => state.isDefault,
    [GET_LOADING_PROMOTIONS](state: IRootState) {
        return state.loadingPromotions;
    },
    [GET_KROGER_AUTH_CONFIG](state: IRootState) {
        return state.krogerAuthConfig;
    },
    [GET_GO_TO_CART_OPEN](state: IRootState) {
        return state.goToCartOpen;
    },
    [GET_INTEGRATED_RETAILER](state: IRootState) {
        return state.config.integratedRetailer;
    },
    [GET_ALL_BASE_INGREDIENTS](state: IRootState, getter) {
        const baseIngredients: number[] = [];
        if (baseIngredients.length > 0) {
            return baseIngredients;
        }
        getter[GET_SHOPPING_LIST].forEach((shoppingList: IShoppingListCategory) => {
            shoppingList.items.forEach((it: IShoppingListItem) => {
                if (it.ingredientId && it.ingredientId > 0) {
                    baseIngredients.push(it.ingredientId);
                }
            });
        });

        getter[GET_PROMOTIONS].forEach((promotion: PromotionCarouselItem) => {
            promotion.defaultPromotions.forEach((p: IPromotion) => {
                if (p.baseIngredientId && p.baseIngredientId > 0) {
                    baseIngredients.push(p.baseIngredientId);
                }
            });
        });
        return [...new Set(baseIngredients)];
    },
    [GET_BASE_INGREDIENTS_PROMOTIONS](state: IRootState, getter) {
        const baseIngredients: number[] = [];

        getter[GET_PROMOTIONS].forEach((promotion: PromotionCarouselItem) => {
            promotion.defaultPromotions.forEach((p: IPromotion) => {
                if (p.baseIngredientId && p.baseIngredientId > 0) {
                    baseIngredients.push(p.baseIngredientId);
                }
            });
        });
        return [...new Set(baseIngredients)];
    },
    [GET_BASE_INGREDIENTS_PROMOTIONS_AND_MAX_OFFERS](state: IRootState, getter) {
        const baseIngredients: {id: number, maxOffers: number}[] = [];

        getter[GET_PROMOTIONS].forEach((promotion: PromotionCarouselItem) => {
            promotion.defaultPromotions.forEach((p: IPromotion) => {
                baseIngredients.push({ id: p.baseIngredientId, maxOffers: p.maxOffers });
            });
        });
        const groupedByMaxOffers = baseIngredients.reduce((r, a) => {
            (r as any)[a.maxOffers] = [...(r as any)[a.maxOffers] || [], a.id];
            return r;
        }, {});
        return groupedByMaxOffers;
    },
    [GET_BASE_INGREDIENTS_BY_SHOPPING_LIST_ID]: (state: IRootState, getter) => (id: number) => {
        const baseIngredients: number[] = [];
        if (baseIngredients.length > 0) {
            return baseIngredients;
        }
        getter[GET_SHOPPING_LIST].forEach((shoppingList: IShoppingListCategory) => {
            if (shoppingList.id === id) {
                shoppingList.items.forEach((it: IShoppingListItem) => {
                    if (it.ingredientId && it.ingredientId > 0) {
                        baseIngredients.push(it.ingredientId);
                    }
                });
            }
        });
        return [...new Set(baseIngredients)];
    },
    [GET_ALL_BASE_INGREDIENTS_AND_MAX_OFFERS](state: IRootState, getter): Dictionary<number[]> {
        const baseIngredients: {id: number, maxOffers: number}[] = [];
        getter[GET_CARDS].forEach((card: ICard) => {
            card.shoppingList.forEach((shoppingList: IShoppingListCategory) => {
                shoppingList.items.forEach((it: IShoppingListItem) => {
                    baseIngredients.push({ id: it.ingredientId, maxOffers: card.maxOffers });
                });
            });
        });
        getter[GET_PROMOTIONS].forEach((promotion: PromotionCarouselItem) => {
            promotion.defaultPromotions.forEach((p: IPromotion) => {
                baseIngredients.push({ id: p.baseIngredientId, maxOffers: p.maxOffers });
            });
        });

        const groupedByMaxOffers: Dictionary<number[]> = {};
        baseIngredients.forEach((bi) => {
            if (!groupedByMaxOffers[bi.maxOffers]) {
                groupedByMaxOffers[bi.maxOffers] = [];
            }
            groupedByMaxOffers[bi.maxOffers].push(bi.id);
        });
        return groupedByMaxOffers;
    },
    [GET_CAROUSEL_BASE_INGREDIENTS](state: IRootState, getter) {
        const result = new Map<number, number>();
        getter[GET_PROMOTIONS].forEach((promotion: PromotionCarouselItem, idx: number) => {
            let r = 0;
            promotion.defaultPromotions.forEach((p: IPromotion) => {
                r = p.baseIngredientId;
            });
            result.set(idx, r);
        });
        return result;
    },
    [GET_ITEM_ID_BASE_INGREDIENT_MAP](state: IRootState): Map<number, number> {
        const result = new Map<number, number>();
        return result;
    },
    [GET_MERCURY_LOCATION_RESULT](state: IRootState): any {
        return state.mercuryLocationResult;
    },
    [GET_FULFILLMENT_STORE](state: IRootState): any {
        return state.fulfillmentStore;
    },

    [GET_ITEM_ID_OFFERS_COUNT](state: IRootState): Map<string, number> {
        const groups = new Map<string, number>();
        if (!state.mxrRetailerLocations[state.currentMxrRetailerIndex]) {
            return groups;
        }
        state.mxrRetailerLocations[state.currentMxrRetailerIndex]
            .Offers
            .forEach((o: RetailerOffer) => {
                const num = groups.get(o.ItemId);
                if (num) {
                    groups.set(o.ItemId, num + 1);
                } else {
                    groups.set(o.ItemId, 1);
                }
            });
        return groups;
    },
    [GET_MXR_CONFIG]: (state: IRootState): IMxrConfig => state.config,
    [GET_MXR_CONFIG_URL]: (state: IRootState): string => state.config.url,
    [GET_SELECTED_SWAP]: (state: IRootState): ProductShoppingListItem => state.selectedSwap,
    [GET_SWAP_OPTIONS]: (state: IRootState): ProductShoppingListItem[] => state.swapOptions,
    [GET_VISIBLE_PROMOTION_STRING]: (state: IRootState): string[] => state.visiblePromotionIds,
    [GET_MAX_OFFERS]: (state: IRootState) => (heading: string): number => state.config.cards[state.activeCardIndex].maxOffers,
    [GET_VISIBLE_PROMOTION_UNIQUE_IDS]: (state: IRootState): string[] => state.visiblePromotionUniqueIds,
    [GET_CHECKOUT_TOTAL]: (state: IRootState): number => state.checkoutTotal,
    [GET_PREVIOUS_PROMOTION]: (state: IRootState): IPromotion | null => state.previousPromotion,
    [GET_OFFERS_COUNT_IN_CART]: (state: IRootState): number => state.offersCountInCart,
    [GET_CARTING_URL]: (state: IRootState, getter): string => {
        const baseCartingUrl = new URL('https://live.polaris.me/api/products/v1/integrations/retailers/cart');
        const { Partner, Chain, FulfillmentStoreId } = getter[GET_CURRENT_MXR_RETAILER];
        const cartItems = getter[GET_SELECTED_PRODUCT_SHOPPING_LIST_ITEMS]
            .filter((p) => p.Upc !== '' && p.Upc !== '000000000000')
            .map((item) => item.Id + ':1').join(',');

        if (!Partner || !cartItems) {
            return '';
        }

        baseCartingUrl.searchParams.append('retailer', Partner);
        baseCartingUrl.searchParams.append('items', cartItems);

        if (Partner === 'kroger' && Chain) {
            baseCartingUrl.searchParams.append('chain', getChainKeyByName(Chain));
        }

        if (FulfillmentStoreId) {
            baseCartingUrl.searchParams.append('storeId', FulfillmentStoreId);
        }
        return baseCartingUrl.toString();
    }
};
